import * as Cookies from 'es-cookie';

interface ClientStorageOptions {
  daysUntilExpire: number;
}

export default class ClientStorage {
  public get<T extends Object>(key: string) {
    const value = Cookies.get(key);
    if (typeof value === 'undefined') {
      return;
    }
    return <T>JSON.parse(value);
  }
  public save(key: string, value: any, options: ClientStorageOptions) {
    Cookies.set(key, JSON.stringify(value), {
      expires: options.daysUntilExpire
    });
  }
  public remove(key: string) {
    Cookies.remove(key);
  }
}
